import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    operatorNotificationSendNewsletterEmails,
    operatorNotificationSendTestEmail,
} from 'src/actions/operator-notifications';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { Entities, fetchAll } from 'src/common';
import { addNotification } from 'src/actions/notifications';
import NotificationAdministrationModal from 'src/components/superadmin/notifications/components/notification-administration-modal';
import composeModalActions from 'src/utils/modal-action-wrapper';

class NotificationAdministrationTestMailModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            testEmail: '',
            error: '',
        };
    }

    handleEmailChange = e => {
        this.setState({
            testEmail: e.target.value,
            error: '',
        });
    };

    sendTestEmail = () => {
        const { testEmail } = this.state;
        const { operatorNotification, operatorNotificationSendTestEmail, addNotification, t } = this.props;

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!testEmail || !emailRegex.test(testEmail)) {
            this.setState({ error: t('operator_notifications.modal.please_enter_valid_mail') });
            return;
        }

        operatorNotificationSendTestEmail(testEmail, operatorNotification)
            .then(() => {
                addNotification(t('operator_notifications.success.test_mail'), '', 'success', 'tr');
            })
            .catch(() => {
                // TODO: show an error notification if you want one
            });
    };

    sendNewsletterNotifications = () => {
        const { operatorNotification, operatorNotificationSendNewsletterEmails, addNotification, handleClose, t } =
            this.props;

        operatorNotificationSendNewsletterEmails(operatorNotification).then(() => {
            handleClose(); // closes the outer modal, as intended
            addNotification(t('operator_notifications.success.mails_sent'), '', 'success', 'tr');
        });
    };

    openEditModal = () => {
        const { handleClose, parentOpenModal, operatorNotification, t } = this.props;

        handleClose();
        parentOpenModal({
            component: NotificationAdministrationModal,
            componentProps: {
                operatorNotificationEdit: operatorNotification,
                isCreate: true,
                openModal: parentOpenModal,
            },
            title: t('user_functionality.edit'),
            mandatoryFields: true,
        });
    };

    componentWillUnmount() {
        this.props.fetchAll(Entities.RECENT_OPERATOR_NOTIFICATIONS);
    }

    render() {
        const { t, handleClose } = this.props;
        const { testEmail, error } = this.state;

        return (
            <div className="row" style={{ padding: '10px' }}>
                <div className="col-md-12">
                    <span>{t('operator_notifications.modal.attention_emails_are_sent_to_all_operators')}</span>
                </div>
                <div
                    className="col-md-12"
                    style={{ marginTop: '10px', marginRight: '10px', display: 'flex', gap: '10px' }}>
                    <input
                        type="email"
                        placeholder="Enter test email address"
                        value={testEmail}
                        onChange={this.handleEmailChange}
                        style={{ borderColor: error ? 'red' : undefined }}
                    />
                    <button
                        onClick={this.sendTestEmail}
                        type="button"
                        className="btn btn-primary"
                        disabled={!testEmail}>
                        {t('operator_notifications.modal.send_test_mail')}
                    </button>
                </div>

                {error && (
                    <div className="col-md-12" style={{ color: 'red', display: 'block', fontSize: '9pt' }}>
                        {error}
                    </div>
                )}

                <div className="col-md-12 " style={{ marginBottom: '10px', marginTop: '20px' }}>
                    <RaisedButton
                        key="editButton"
                        label={t('user_functionality.edit')}
                        primary={true}
                        onClick={this.openEditModal}
                        labelColor="#ffffff"
                        className="pull-left"
                    />
                    <RaisedButton
                        key="sendButton"
                        label={t('user_functionality.send')}
                        primary={true}
                        onClick={this.sendNewsletterNotifications}
                        labelColor="#ffffff"
                        className="pull-right"
                    />
                    <FlatButton
                        key="cancelButton"
                        label={t('common_phrases.abort')}
                        default={true}
                        onClick={handleClose}
                        className="pull-right"
                    />
                </div>
            </div>
        );
    }
}

export default connect(
    null,
    { operatorNotificationSendTestEmail, operatorNotificationSendNewsletterEmails, fetchAll, addNotification },
    null,
)(composeModalActions(NotificationAdministrationTestMailModal));
